module.exports = __webpack_public_path__ + "static/media/second_card.9807ccf0.svg";